import React, { useEffect } from 'react'
import styles from "./WhyUs.module.css"
import side from "../../assets/CircleDraw.png"
import Circle from '../../Components/CenterCircle/Circle'
import CircleMobile from '../../Components/CenterCircle/CircleMobile'
import Body from '../../Components/Body/Body'
import Contact from '../../Components/Contact/Contact'
import AnimiatedPage from '../../AnimiatedPage'


function WhysUs() {
    useEffect(()=>{
        document.title = 'SHARVIL Business Group-Why Us'
        },[])
    return (
        <AnimiatedPage>
            <div className={styles.whyus}>
            <div data-aos = "slide-right"  className={styles.whyusHead}>
                <h3 style={{ color: '#066263' }}>我々の存在意義 <span>WHY US</span></h3>
            </div>
            <div className={styles.whyusBody}>
                <div data-aos = "slide-left" className={styles.whyusBodyTop}>
                    <div  >
<p>グローバルな視点から, グローバルな方法で, 最適なソリューションを提供する。</p>

                    </div>
                </div>
                <div className={styles.whyusBodyBox}>
                    <div className={styles.whyusBodyBoxPara}>

                        <p>現在、日本国内のみで事業を行っていても海外における事象が事業に影響を大きく与えることも珍しくなくなりました。</p>
                        <p>円安、ウクライナ情勢などこれまではそこまで大きく売上や利益に影響を与えていなかったような事情まで事業計画に組み込まなければなりません。</p>

                        <p>ただ、グローバルな視点を本当の意味で持つことは非常に難しいです。というのも、”学んだ”視点はあくまでも、学んだものであり実際の生の視点でも、自身で会得したものではないからです。</p>
                                    
                                    <p>そこで我々が存在する意味が生まれます。世界中に点在している弊社スタッフがいます。IT大国であるインドに拠点を持っています。
                        取引を含めて非常に多くの知見と、経験を持つ弊社のエージェントがいます。</p>
    
                                           <p> 本当の意味での”グローバル”な視点を持ち、それらを活用した最適なソリューションを提供することができます。</p>
                                                        </div>
                    </div>
                        <div className ={`${styles.sideimage} ${styles.rotating}`}>
                            <img src={side} alt="Circle" />
                    </div>
                </div>
               {/* <div ref={ref} className={`${isVisible ? styles.show : styles.hide} ${styles.aboutdiv}`}> */}
               <Circle/>
               <CircleMobile/>
               {/* </div> */}
               
                
               <Body whyUs/>

              
               <Contact whyUs/>
               
            </div>
        </AnimiatedPage>
    )
}
                    
export default WhysUs                